import { LoggedUser } from './ApiService/Subscription/SubscriptionApiClient';

export enum Permissions {
    MANAGE_CONTACT_SUBSCRIPTIONS = 'MANAGE_CONTACT_SUBSCRIPTIONS',
    MANAGE_VENDORS = 'MANAGE_VENDORS',
    SGM_DEFAULT = 'SGM_DEFAULT',
}


const convertUserPermissions = (user?: LoggedUser | null): Permissions[] => {
    if (!user?.permissions?.length) {
        return [];
    }

    return user.permissions.map((up) => up as Permissions);
};

export const hasAnyRight = (user: LoggedUser | null | undefined, permissions: Permissions[]): boolean => {
    const userPermissions = convertUserPermissions(user);
    if (userPermissions && userPermissions.length) {
        return userPermissions.some((up) => permissions.includes(up));
    }
    return false;
};
